import React, { useEffect, useState } from "react";
import ProductFilterDialog from "./ProductFilterDialog";
import { useDispatch } from "react-redux";
import { setFilterBy } from "src/redux/slices/ProductSlice";
import { useGetProductFilterDataForFilterMutation } from "src/services/ProductService";

const ProductFilterDialogWrapper = () => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState({
    courseOptions: [],
    levelOptions: [],
    subjectOptions: [],
    facultyOptions: [],
    groupOptions: [],
    moduleOptions: [],
    modeOptions: [],
    categoryOptions: [],
    syllabusOptions: [],
    instituteOptions: [],
  });

  const [isOptionLoading, setIsOptionLoading] = useState(true);
  const [getFilterData] = useGetProductFilterDataForFilterMutation();
  const [filterValues, setFilterValues] = useState({
    course: "",
    level: "",
    subject: "",
    faculty: "",
    group: "",
    module: "",
    mode: "",
    category: "",
    syllabus: "",
    institute: "",
  });
  useEffect(() => {
    setIsOptionLoading(true);
    getFilterData({
      courseUrlSlug: filterValues.course,
      levelCode: filterValues.level,
      subjectUrlSlug: filterValues.subject ? [filterValues.subject] : [],
      facultyUrlSlug: filterValues.faculty ? [filterValues.faculty] : [],
      groupName: filterValues.group,
      moduleName: filterValues.module,
      syllabusName: filterValues.syllabus,
      modeCode: filterValues.mode,
      categoryCode: filterValues.category,
      instituteName: filterValues.institute,
    }).then((res: any) => {
      if (res?.data?.status) {
        const courseOptions = res?.data?.data?.course?.map((c: any) => ({
          label: c.courseName,
          value: c.courseUrlSlug,
        }));

        const subjectOptions = res?.data.data?.subject?.map((sub: any) => {
          return {
            label: sub.subjectName,
            value: sub.subjectUrlSlug,
          };
        });

        const facultyOptions = res?.data.data?.faculty?.map((fac: any) => {
          return {
            label: fac.facultyName,
            value: fac.facultyUrlSlug,
          };
        });

        const groupOptions = res?.data.data?.groups?.map((g: string) => {
          return {
            label: g,
            value: g,
          };
        });
        const instituteOptions = res?.data.data?.institute?.map((i: any) => {
          return {
            label: i.instituteName,
            value: i.instituteName,
          };
        });

        const syllabusOptions = res?.data?.data?.syllabus?.map((s: any) => {
          return {
            label: s,
            value: s,
          };
        });
        const moduleOptions = res?.data?.data?.modules?.map((m: any) => {
          return {
            label: m,
            value: m,
          };
        });
        const modeOptions = res?.data?.data?.mode?.map((m: any) => {
          return {
            label: m,
            value: m,
          };
        });
        const categoryOptions = res?.data?.data?.category?.map((c: any) => {
          return {
            label: c,
            value: c,
          };
        });
        const levelOptions = res?.data?.data?.level?.map((l: any) => {
          return {
            label: l.levelName,
            value: l.levelCode,
          };
        });
        setOptions(() => ({
          courseOptions,
          levelOptions,
          syllabusOptions,
          facultyOptions,
          groupOptions,
          subjectOptions,
          modeOptions,
          moduleOptions,
          categoryOptions,
          instituteOptions,
        }));

        // if (filterValues.course) {
        //   const selectedCourse = res?.data?.data?.course?.find(
        //     (c: any) => c.courseUrlSlug === filterValues.course
        //   );

        //   if (selectedCourse) {
        //     const levelOptions = selectedCourse?.levels?.map((l: any) => {
        //       return {
        //         value: l.levelCode,
        //         label: l.levelName,
        //       };
        //     });
        //     setOptions({
        //       ...options,
        //       levelOptions,
        //     });
        //   } else {
        //     setOptions({
        //       ...options,
        //       levelOptions: [],
        //     });
        //   }
        // }

        setIsOptionLoading(false);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues]);
  const handleChangeFilterValue = (fieldName: string, value: string) => {
    setFilterValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };
  useEffect(() => {
    dispatch(setFilterBy([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSearch = () => {
    const {
      course,
      level,
      subject,
      faculty,
      syllabus,
      group,
      module,
      mode,
      category,
      institute,
    } = filterValues;
    //as it is
    const filterList = [
      {
        fieldName: "courseUrlSlug",
        value: course ? [course] : [],
      },
      {
        fieldName: "levelCode",
        value: level ? [level] : [],
      },
      {
        fieldName: "instituteName",
        value: institute ? [institute] : [],
      },
      {
        fieldName: "subject.subjectUrlSlug",
        value: subject ? [subject] : [],
      },
      {
        fieldName: "faculty.facultyUrlSlug",
        value: faculty ? [faculty] : [],
      },
      {
        fieldName: "categoryName",
        value: category ? [category] : [],
      },

      {
        fieldName: "modeName",
        value: mode ? [mode] : [],
      },
      {
        fieldName: "syllabusName",
        value: syllabus ? [syllabus] : [],
      },
      {
        fieldName: "groupName",
        value: group ? [group] : [],
      },
      {
        fieldName: "moduleName",
        value: module ? [module] : [],
      },
    ]; //as it is
    dispatch(setFilterBy(filterList));
  };
  return (
    <ProductFilterDialog
      options={options}
      filterValues={filterValues}
      setFilterValues={handleChangeFilterValue}
      isOptionLoading={isOptionLoading}
      onSearch={() => {
        handleSearch();
      }}
      isProductLoading={false}
    />
  );
};

export default ProductFilterDialogWrapper;
